import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useBrowserNavigation = () => {
  const router = useRouter();

  useEffect(() => {
    const handlePopState = () => {
      // Get the current URL from the browser
      const currentPath = window.location.pathname + window.location.search + window.location.hash;

      // Use router.replace with scroll: false to prevent scroll issues
      // but force a full re-render
      router
        .replace(currentPath, undefined, { scroll: false })
        .then(() => {
          // Force re-render by triggering routeChangeComplete
          router.events.emit('routeChangeComplete', currentPath);
        })
        .catch((error) => {
          console.error('Navigation failed:', error);
        });
    };

    // Listen for browser navigation events (back/forward buttons)
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [router]);
};
